// src/phone-input/constants.ts
var COUNTRIES = {
  AU: { label: "Australia", id: "AU", dialCode: "+61" },
  GB: { label: "United Kingdom", id: "GB", dialCode: "+44" },
  US: { label: "United States", id: "US", dialCode: "+1" },
  NZ: { label: "New Zealand", id: "NZ", dialCode: "+64" },
  SG: { label: "Singapore", id: "SG", dialCode: "+65" },
  AF: { label: "Afghanistan (\u202B\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646\u202C\u200E)", id: "AF", dialCode: "+93" },
  AL: { label: "Albania (Shqip\xEBri)", id: "AL", dialCode: "+355" },
  DZ: { label: "Algeria (\u202B\u0627\u0644\u062C\u0632\u0627\u0626\u0631\u202C\u200E)", id: "DZ", dialCode: "+213" },
  AS: { label: "American Samoa", id: "AS", dialCode: "+1684" },
  AD: { label: "Andorra", id: "AD", dialCode: "+376" },
  AO: { label: "Angola", id: "AO", dialCode: "+244" },
  AI: { label: "Anguilla", id: "AI", dialCode: "+1264" },
  AG: { label: "Antigua and Barbuda", id: "AG", dialCode: "+1268" },
  AR: { label: "Argentina", id: "AR", dialCode: "+54" },
  AM: { label: "Armenia (\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576)", id: "AM", dialCode: "+374" },
  AW: { label: "Aruba", id: "AW", dialCode: "+297" },
  AT: { label: "Austria (\xD6sterreich)", id: "AT", dialCode: "+43" },
  AZ: { label: "Azerbaijan (Az\u0259rbaycan)", id: "AZ", dialCode: "+994" },
  BS: { label: "Bahamas", id: "BS", dialCode: "+1242" },
  BH: { label: "Bahrain (\u202B\u0627\u0644\u0628\u062D\u0631\u064A\u0646\u202C\u200E)", id: "BH", dialCode: "+973" },
  BD: { label: "Bangladesh (\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6)", id: "BD", dialCode: "+880" },
  BB: { label: "Barbados", id: "BB", dialCode: "+1246" },
  BY: { label: "Belarus (\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C)", id: "BY", dialCode: "+375" },
  BE: { label: "Belgium (Belgi\xEB)", id: "BE", dialCode: "+32" },
  BZ: { label: "Belize", id: "BZ", dialCode: "+501" },
  BJ: { label: "Benin (B\xE9nin)", id: "BJ", dialCode: "+229" },
  BM: { label: "Bermuda", id: "BM", dialCode: "+1441" },
  BT: { label: "Bhutan (\u0F60\u0F56\u0FB2\u0F74\u0F42)", id: "BT", dialCode: "+975" },
  BO: { label: "Bolivia", id: "BO", dialCode: "+591" },
  BA: {
    label: "Bosnia and Herzegovina (\u0411\u043E\u0441\u043D\u0430 \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430)",
    id: "BA",
    dialCode: "+387"
  },
  BW: { label: "Botswana", id: "BW", dialCode: "+267" },
  BR: { label: "Brazil (Brasil)", id: "BR", dialCode: "+55" },
  IO: { label: "British Indian Ocean Territory", id: "IO", dialCode: "+246" },
  VG: { label: "British Virgin Islands", id: "VG", dialCode: "+1284" },
  BN: { label: "Brunei", id: "BN", dialCode: "+673" },
  BG: { label: "Bulgaria (\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F)", id: "BG", dialCode: "+359" },
  BF: { label: "Burkina Faso", id: "BF", dialCode: "+226" },
  BI: { label: "Burundi (Uburundi)", id: "BI", dialCode: "+257" },
  KH: { label: "Cambodia (\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6)", id: "KH", dialCode: "+855" },
  CM: { label: "Cameroon (Cameroun)", id: "CM", dialCode: "+237" },
  CA: { label: "Canada", id: "CA", dialCode: "+1" },
  CV: { label: "Cape Verde (Kabu Verdi)", id: "CV", dialCode: "+238" },
  KY: { label: "Cayman Islands", id: "KY", dialCode: "+1345" },
  CF: {
    label: "Central African Republic (R\xE9publique centrafricaine)",
    id: "CF",
    dialCode: "+236"
  },
  TD: { label: "Chad (Tchad)", id: "TD", dialCode: "+235" },
  CL: { label: "Chile", id: "CL", dialCode: "+56" },
  CN: { label: "China (\u4E2D\u56FD)", id: "CN", dialCode: "+86" },
  CX: { label: "Christmas Island", id: "CX", dialCode: "+61" },
  CC: { label: "Cocos (Keeling) Islands", id: "CC", dialCode: "+61" },
  CO: { label: "Colombia", id: "CO", dialCode: "+57" },
  KM: { label: "Comoros (\u202B\u062C\u0632\u0631 \u0627\u0644\u0642\u0645\u0631\u202C\u200E)", id: "KM", dialCode: "+269" },
  CD: {
    label: "Congo (DRC) (Jamhuri ya Kisoemokrasia ya Kongo)",
    id: "CD",
    dialCode: "+243"
  },
  CG: {
    label: "Congo (Republic) (Congo-Brazzaville)",
    id: "CG",
    dialCode: "+242"
  },
  CK: { label: "Cook Islands", id: "CK", dialCode: "+682" },
  CR: { label: "Costa Rica", id: "CR", dialCode: "+506" },
  CI: { label: "C\xF4te d\u2019Ivoire", id: "CI", dialCode: "+225" },
  HR: { label: "Croatia (Hrvatska)", id: "HR", dialCode: "+385" },
  CU: { label: "Cuba", id: "CU", dialCode: "+53" },
  CW: { label: "Cura\xE7ao", id: "CW", dialCode: "+599" },
  CY: { label: "Cyprus (\u039A\u03CD\u03C0\u03C1\u03BF\u03C2)", id: "CY", dialCode: "+357" },
  CZ: { label: "Czech Republic (\u010Cesk\xE1 republika)", id: "CZ", dialCode: "+420" },
  DK: { label: "Denmark (Danmark)", id: "DK", dialCode: "+45" },
  DJ: { label: "Djibouti", id: "DJ", dialCode: "+253" },
  DM: { label: "Dominica", id: "DM", dialCode: "+1767" },
  DO: {
    label: "Dominican Republic (Rep\xFAblica Dominicana)",
    id: "DO",
    dialCode: "+1"
  },
  EC: { label: "Ecuador", id: "EC", dialCode: "+593" },
  EG: { label: "Egypt (\u202B\u0645\u0635\u0631\u202C\u200E)", id: "EG", dialCode: "+20" },
  SV: { label: "El Salvador", id: "SV", dialCode: "+503" },
  GQ: {
    label: "Equatorial Guinea (Guinea Ecuatorial)",
    id: "GQ",
    dialCode: "+240"
  },
  ER: { label: "Eritrea", id: "ER", dialCode: "+291" },
  EE: { label: "Estonia (Eesti)", id: "EE", dialCode: "+372" },
  ET: { label: "Ethiopia", id: "ET", dialCode: "+251" },
  FK: {
    label: "Falkland Islands (Islas Malvinas)",
    id: "FK",
    dialCode: "+500"
  },
  FO: { label: "Faroe Islands (F\xF8royar)", id: "FO", dialCode: "+298" },
  FJ: { label: "Fiji", id: "FJ", dialCode: "+679" },
  FI: { label: "Finland (Suomi)", id: "FI", dialCode: "+358" },
  FR: { label: "France", id: "FR", dialCode: "+33" },
  GF: { label: "French Guiana (Guyane fran\xE7aise)", id: "GF", dialCode: "+594" },
  PF: {
    label: "French Polynesia (Polyn\xE9sie fran\xE7aise)",
    id: "PF",
    dialCode: "+689"
  },
  GA: { label: "Gabon", id: "GA", dialCode: "+241" },
  GM: { label: "Gambia", id: "GM", dialCode: "+220" },
  GE: { label: "Georgia (\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD)", id: "GE", dialCode: "+995" },
  DE: { label: "Germany (Deutschland)", id: "DE", dialCode: "+49" },
  GH: { label: "Ghana (Gaana)", id: "GH", dialCode: "+233" },
  GI: { label: "Gibraltar", id: "GI", dialCode: "+350" },
  GR: { label: "Greece (\u0395\u03BB\u03BB\u03AC\u03B4\u03B1)", id: "GR", dialCode: "+30" },
  GL: { label: "Greenland (Kalaallit Nunaat)", id: "GL", dialCode: "+299" },
  GD: { label: "Grenada", id: "GD", dialCode: "+1473" },
  GP: { label: "Guadeloupe", id: "GP", dialCode: "+590" },
  GU: { label: "Guam", id: "GU", dialCode: "+1671" },
  GT: { label: "Guatemala", id: "GT", dialCode: "+502" },
  GG: { label: "Guernsey", id: "GG", dialCode: "+44" },
  GN: { label: "Guinea (Guin\xE9e)", id: "GN", dialCode: "+224" },
  GW: { label: "Guinea-Bissau (Guin\xE9 Bissau)", id: "GW", dialCode: "+245" },
  GY: { label: "Guyana", id: "GY", dialCode: "+592" },
  HT: { label: "Haiti", id: "HT", dialCode: "+509" },
  HN: { label: "Honduras", id: "HN", dialCode: "+504" },
  HK: { label: "Hong Kong (\u9999\u6E2F)", id: "HK", dialCode: "+852" },
  HU: { label: "Hungary (Magyarorsz\xE1g)", id: "HU", dialCode: "+36" },
  IS: { label: "Iceland (\xCDsland)", id: "IS", dialCode: "+354" },
  IN: { label: "India (\u092D\u093E\u0930\u0924)", id: "IN", dialCode: "+91" },
  ID: { label: "Indonesia", id: "ID", dialCode: "+62" },
  IR: { label: "Iran (\u202B\u0627\u06CC\u0631\u0627\u0646\u202C\u200E)", id: "IR", dialCode: "+98" },
  IQ: { label: "Iraq (\u202B\u0627\u0644\u0639\u0631\u0627\u0642\u202C\u200E)", id: "IQ", dialCode: "+964" },
  IE: { label: "Ireland", id: "IE", dialCode: "+353" },
  IM: { label: "Isle of Man", id: "IM", dialCode: "+44" },
  IL: { label: "Israel (\u202B\u05D9\u05E9\u05E8\u05D0\u05DC\u202C\u200E)", id: "IL", dialCode: "+972" },
  IT: { label: "Italy (Italia)", id: "IT", dialCode: "+39" },
  JM: { label: "Jamaica", id: "JM", dialCode: "+1" },
  JP: { label: "Japan (\u65E5\u672C)", id: "JP", dialCode: "+81" },
  JE: { label: "Jersey", id: "JE", dialCode: "+44" },
  JO: { label: "Jordan (\u202B\u0627\u0644\u0623\u0631\u062F\u0646\u202C\u200E)", id: "JO", dialCode: "+962" },
  KZ: { label: "Kazakhstan (\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D)", id: "KZ", dialCode: "+7" },
  KE: { label: "Kenya", id: "KE", dialCode: "+254" },
  KI: { label: "Kiribati", id: "KI", dialCode: "+686" },
  XK: { label: "Kosovo", id: "XK", dialCode: "+383" },
  KW: { label: "Kuwait (\u202B\u0627\u0644\u0643\u0648\u064A\u062A\u202C\u200E)", id: "KW", dialCode: "+965" },
  KG: { label: "Kyrgyzstan (\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D)", id: "KG", dialCode: "+996" },
  LA: { label: "Laos (\u0EA5\u0EB2\u0EA7)", id: "LA", dialCode: "+856" },
  LV: { label: "Latvia (Latvija)", id: "LV", dialCode: "+371" },
  LB: { label: "Lebanon (\u202B\u0644\u0628\u0646\u0627\u0646\u202C\u200E)", id: "LB", dialCode: "+961" },
  LS: { label: "Lesotho", id: "LS", dialCode: "+266" },
  LR: { label: "Liberia", id: "LR", dialCode: "+231" },
  LY: { label: "Libya (\u202B\u0644\u064A\u0628\u064A\u0627\u202C\u200E)", id: "LY", dialCode: "+218" },
  LI: { label: "Liechtenstein", id: "LI", dialCode: "+423" },
  LT: { label: "Lithuania (Lietuva)", id: "LT", dialCode: "+370" },
  LU: { label: "Luxembourg", id: "LU", dialCode: "+352" },
  MO: { label: "Macau (\u6FB3\u9580)", id: "MO", dialCode: "+853" },
  MK: {
    label: "North Macedonia (FYROM) (\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430)",
    id: "MK",
    dialCode: "+389"
  },
  MG: { label: "Madagascar (Madagasikara)", id: "MG", dialCode: "+261" },
  MW: { label: "Malawi", id: "MW", dialCode: "+265" },
  MY: { label: "Malaysia", id: "MY", dialCode: "+60" },
  MV: { label: "Maldives", id: "MV", dialCode: "+960" },
  ML: { label: "Mali", id: "ML", dialCode: "+223" },
  MT: { label: "Malta", id: "MT", dialCode: "+356" },
  MH: { label: "Marshall Islands", id: "MH", dialCode: "+692" },
  MQ: { label: "Martinique", id: "MQ", dialCode: "+596" },
  MR: { label: "Mauritania (\u202B\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627\u202C\u200E)", id: "MR", dialCode: "+222" },
  MU: { label: "Mauritius (Moris)", id: "MU", dialCode: "+230" },
  YT: { label: "Mayotte", id: "YT", dialCode: "+262" },
  MX: { label: "Mexico (M\xE9xico)", id: "MX", dialCode: "+52" },
  FM: { label: "Micronesia", id: "FM", dialCode: "+691" },
  MD: { label: "Moldova (Republica Moldova)", id: "MD", dialCode: "+373" },
  MC: { label: "Monaco", id: "MC", dialCode: "+377" },
  MN: { label: "Mongolia (\u041C\u043E\u043D\u0433\u043E\u043B)", id: "MN", dialCode: "+976" },
  ME: { label: "Montenegro (Crna Gora)", id: "ME", dialCode: "+382" },
  MS: { label: "Montserrat", id: "MS", dialCode: "+1664" },
  MA: { label: "Morocco (\u202B\u0627\u0644\u0645\u063A\u0631\u0628\u202C\u200E)", id: "MA", dialCode: "+212" },
  MZ: { label: "Mozambique (Mo\xE7ambique)", id: "MZ", dialCode: "+258" },
  MM: { label: "Myanmar (Burma) (\u1019\u103C\u1014\u103A\u1019\u102C)", id: "MM", dialCode: "+95" },
  NA: { label: "Namibia (Namibi\xEB)", id: "NA", dialCode: "+264" },
  NR: { label: "Nauru", id: "NR", dialCode: "+674" },
  NP: { label: "Nepal (\u0928\u0947\u092A\u093E\u0932)", id: "NP", dialCode: "+977" },
  NL: { label: "Netherlands (Nederland)", id: "NL", dialCode: "+31" },
  NC: {
    label: "New Caledonia (Nouvelle-Cal\xE9donie)",
    id: "NC",
    dialCode: "+687"
  },
  NI: { label: "Nicaragua", id: "NI", dialCode: "+505" },
  NE: { label: "Niger (Nijar)", id: "NE", dialCode: "+227" },
  NG: { label: "Nigeria", id: "NG", dialCode: "+234" },
  NU: { label: "Niue", id: "NU", dialCode: "+683" },
  NF: { label: "Norfolk Island", id: "NF", dialCode: "+672" },
  KP: {
    label: "North Korea (\uC870\uC120 \uBBFC\uC8FC\uC8FC\uC758 \uC778\uBBFC \uACF5\uD654\uAD6D)",
    id: "KP",
    dialCode: "+850"
  },
  MP: { label: "Northern Mariana Islands", id: "MP", dialCode: "+1670" },
  NO: { label: "Norway (Norge)", id: "NO", dialCode: "+47" },
  OM: { label: "Oman (\u202B\u0639\u064F\u0645\u0627\u0646\u202C\u200E)", id: "OM", dialCode: "+968" },
  PK: { label: "Pakistan (\u202B\u067E\u0627\u06A9\u0633\u062A\u0627\u0646\u202C\u200E)", id: "PK", dialCode: "+92" },
  PW: { label: "Palau", id: "PW", dialCode: "+680" },
  PS: { label: "Palestine (\u202B\u0641\u0644\u0633\u0637\u064A\u0646\u202C\u200E)", id: "PS", dialCode: "+970" },
  PA: { label: "Panama (Panam\xE1)", id: "PA", dialCode: "+507" },
  PG: { label: "Papua New Guinea", id: "PG", dialCode: "+675" },
  PY: { label: "Paraguay", id: "PY", dialCode: "+595" },
  PE: { label: "Peru (Per\xFA)", id: "PE", dialCode: "+51" },
  PH: { label: "Philippines", id: "PH", dialCode: "+63" },
  PL: { label: "Poland (Polska)", id: "PL", dialCode: "+48" },
  PT: { label: "Portugal", id: "PT", dialCode: "+351" },
  PR: { label: "Puerto Rico", id: "PR", dialCode: "+1" },
  QA: { label: "Qatar (\u202B\u0642\u0637\u0631\u202C\u200E)", id: "QA", dialCode: "+974" },
  RE: { label: "R\xE9union (La R\xE9union)", id: "RE", dialCode: "+262" },
  RO: { label: "Romania (Rom\xE2nia)", id: "RO", dialCode: "+40" },
  RU: { label: "Russia (\u0420\u043E\u0441\u0441\u0438\u044F)", id: "RU", dialCode: "+7" },
  RW: { label: "Rwanda", id: "RW", dialCode: "+250" },
  BL: { label: "Saint Barth\xE9lemy", id: "BL", dialCode: "+590" },
  SH: { label: "Saint Helena", id: "SH", dialCode: "+290" },
  KN: { label: "Saint Kitts and Nevis", id: "KN", dialCode: "+1869" },
  LC: { label: "Saint Lucia", id: "LC", dialCode: "+1758" },
  MF: {
    label: "Saint Martin (Saint-Martin (partie fran\xE7aise))",
    id: "MF",
    dialCode: "+590"
  },
  PM: {
    label: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    id: "PM",
    dialCode: "+508"
  },
  VC: {
    label: "Saint Vincent and the Grenadines",
    id: "VC",
    dialCode: "+1784"
  },
  WS: { label: "Samoa", id: "WS", dialCode: "+685" },
  SM: { label: "San Marino", id: "SM", dialCode: "+378" },
  ST: {
    label: "S\xE3o Tom\xE9 and Pr\xEDncipe (S\xE3o Tom\xE9 e Pr\xEDncipe)",
    id: "ST",
    dialCode: "+239"
  },
  SA: {
    label: "Saudi Arabia (\u202B\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629\u202C\u200E)",
    id: "SA",
    dialCode: "+966"
  },
  SN: { label: "Senegal (S\xE9n\xE9gal)", id: "SN", dialCode: "+221" },
  RS: { label: "Serbia (\u0421\u0440\u0431\u0438\u0458\u0430)", id: "RS", dialCode: "+381" },
  SC: { label: "Seychelles", id: "SC", dialCode: "+248" },
  SL: { label: "Sierra Leone", id: "SL", dialCode: "+232" },
  SX: { label: "Sint Maarten", id: "SX", dialCode: "+1721" },
  SK: { label: "Slovakia (Slovensko)", id: "SK", dialCode: "+421" },
  SI: { label: "Slovenia (Slovenija)", id: "SI", dialCode: "+386" },
  SB: { label: "Solomon Islands", id: "SB", dialCode: "+677" },
  SO: { label: "Somalia (Soomaaliya)", id: "SO", dialCode: "+252" },
  ZA: { label: "South Africa", id: "ZA", dialCode: "+27" },
  KR: { label: "South Korea (\uB300\uD55C\uBBFC\uAD6D)", id: "KR", dialCode: "+82" },
  SS: { label: "South Sudan (\u202B\u062C\u0646\u0648\u0628 \u0627\u0644\u0633\u0648\u062F\u0627\u0646\u202C\u200E)", id: "SS", dialCode: "+211" },
  ES: { label: "Spain (Espa\xF1a)", id: "ES", dialCode: "+34" },
  LK: { label: "Sri Lanka (\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF\u0DC0)", id: "LK", dialCode: "+94" },
  SD: { label: "Sudan (\u202B\u0627\u0644\u0633\u0648\u062F\u0627\u0646\u202C\u200E)", id: "SD", dialCode: "+249" },
  SR: { label: "Suriname", id: "SR", dialCode: "+597" },
  SJ: { label: "Svalbard and Jan Mayen", id: "SJ", dialCode: "+47" },
  SZ: { label: "Swaziland", id: "SZ", dialCode: "+268" },
  SE: { label: "Sweden (Sverige)", id: "SE", dialCode: "+46" },
  CH: { label: "Switzerland (Schweiz)", id: "CH", dialCode: "+41" },
  SY: { label: "Syria (\u202B\u0633\u0648\u0631\u064A\u0627\u202C\u200E)", id: "SY", dialCode: "+963" },
  TW: { label: "Taiwan (\u53F0\u7063)", id: "TW", dialCode: "+886" },
  TJ: { label: "Tajikistan", id: "TJ", dialCode: "+992" },
  TZ: { label: "Tanzania", id: "TZ", dialCode: "+255" },
  TH: { label: "Thailand (\u0E44\u0E17\u0E22)", id: "TH", dialCode: "+66" },
  TL: { label: "Timor-Leste", id: "TL", dialCode: "+670" },
  TG: { label: "Togo", id: "TG", dialCode: "+228" },
  TK: { label: "Tokelau", id: "TK", dialCode: "+690" },
  TO: { label: "Tonga", id: "TO", dialCode: "+676" },
  TT: { label: "Trinisoad and Tobago", id: "TT", dialCode: "+1868" },
  TN: { label: "Tunisia (\u202B\u062A\u0648\u0646\u0633\u202C\u200E)", id: "TN", dialCode: "+216" },
  TR: { label: "Turkey (T\xFCrkiye)", id: "TR", dialCode: "+90" },
  TM: { label: "Turkmenistan", id: "TM", dialCode: "+993" },
  TC: { label: "Turks and Caicos Islands", id: "TC", dialCode: "+1649" },
  TV: { label: "Tuvalu", id: "TV", dialCode: "+688" },
  VI: { label: "U.S. Virgin Islands", id: "VI", dialCode: "+1340" },
  UG: { label: "Uganda", id: "UG", dialCode: "+256" },
  UA: { label: "Ukraine (\u0423\u043A\u0440\u0430\u0457\u043D\u0430)", id: "UA", dialCode: "+380" },
  AE: {
    label: "United Arab Emirates (\u202B\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629\u202C\u200E)",
    id: "AE",
    dialCode: "+971"
  },
  UY: { label: "Uruguay", id: "UY", dialCode: "+598" },
  UZ: { label: "Uzbekistan (O\u02BBzbekiston)", id: "UZ", dialCode: "+998" },
  VU: { label: "Vanuatu", id: "VU", dialCode: "+678" },
  VA: { label: "Vatican City (Citt\xE0 del Vaticano)", id: "VA", dialCode: "+39" },
  VE: { label: "Venezuela", id: "VE", dialCode: "+58" },
  VN: { label: "Vietnam (Vi\u1EC7t Nam)", id: "VN", dialCode: "+84" },
  WF: {
    label: "Wallis and Futuna (Wallis-et-Futuna)",
    id: "WF",
    dialCode: "+681"
  },
  YE: { label: "Yemen (\u202B\u0627\u0644\u064A\u0645\u0646\u202C\u200E)", id: "YE", dialCode: "+967" },
  ZM: { label: "Zambia", id: "ZM", dialCode: "+260" },
  ZW: { label: "Zimbabwe", id: "ZW", dialCode: "+263" },
  AX: { label: "\xC5land Islands", id: "AX", dialCode: "+358" }
};

export {
  COUNTRIES
};
